import { render, staticRenderFns } from "./UITabs.vue?vue&type=template&id=3192dbdc&"
import script from "./UITabs.vue?vue&type=script&lang=js&"
export * from "./UITabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports